import {Box, Button, Heading, Text} from '@primer/react'
import {useState} from 'react'

import type {
  CopilotAgentConfirmation,
  CopilotClientConfirmation,
  CopilotClientConfirmationState,
} from '../utils/copilot-chat-types'
import {useChatState} from '../utils/CopilotChatContext'

export interface ConfirmationProps {
  confirmation: CopilotAgentConfirmation
  handleConfirmation: (
    clientConfirmation: CopilotClientConfirmation,
    confirmationTitle: string,
    onSubmit?: (accepted: boolean) => void,
  ) => void
  isLatestMessage?: boolean
}

export function Confirmation({confirmation, handleConfirmation, isLatestMessage}: ConfirmationProps) {
  const state = useChatState()
  const confirmationConfirmation = JSON.stringify(Object.values(confirmation.confirmation).sort())
  const clientConfirmationExists = state.allClientConfirmations?.includes(confirmationConfirmation)
  const {isWaitingOnCopilot} = state
  const [actionTaken, setActionTaken] = useState(clientConfirmationExists && !isLatestMessage)
  const handleUserAction = (action: CopilotClientConfirmationState) => {
    setActionTaken(true)
    handleConfirmation(
      {state: action, confirmation: confirmation.confirmation},
      confirmation.title,
      confirmation.onSubmit,
    )
  }

  return (
    <Box className="border rounded-2" sx={{display: 'flex', flexDirection: 'column', p: 3, marginTop: 3}}>
      <Heading as="h3" sx={{mb: 1, fontSize: 1, lineHeight: 'condensed'}}>
        {confirmation.title}
      </Heading>
      {confirmation.message.split('\n').map(message => (
        <Text key={message} as="p" sx={{color: 'fg.muted', mb: 0}}>
          {message}
        </Text>
      ))}
      {!actionTaken && (
        <Box sx={{display: 'flex', justifyContent: 'flex-start', gap: 2, mt: 3}}>
          <Button disabled={isWaitingOnCopilot} variant="primary" onClick={() => handleUserAction('accepted')}>
            Allow
          </Button>
          <Button disabled={isWaitingOnCopilot} onClick={() => handleUserAction('dismissed')}>
            Dismiss
          </Button>
        </Box>
      )}
    </Box>
  )
}

try{ Confirmation.displayName ||= 'Confirmation' } catch {}